import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuthContext } from "./AuthContext";

export function ProtectedRoute() {
  const { user, isLoading } = useAuthContext();
  const location = useLocation();

  if (isLoading) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "var(--bg)" }}>
        <span style={{ font: "500 13px 'Golos Text',sans-serif", color: "var(--fg3)" }}>Загрузка…</span>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
}

export function AdminRoute() {
  const { isAdmin } = useAuthContext();
  if (!isAdmin) return <Navigate to="/" replace />;
  return <Outlet />;
}
